"use strict";

module.exports = function () {
  return this.data;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/computed/table-data.js
// module id = 2185
// module chunks = 0